import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import ReactTable from "react-table"
import jsPDF from "jspdf"
import { loadingStatus, setTableExporting } from "actions"
import html2canvas from "html2canvas"
import moment from 'moment'
import helpers from 'helpers/helpers'
const computedStyleToInlineStyle = require("computed-style-to-inline-style")
// This container is for the Export to JPG feature on all tables.
class TablePrinter extends Component {
	constructor(props) {
		super(props)
		this.state = {
			limit: 75,
			model: { active: false, data: {}, sorted: [], columns: [], title: "", paddingTop: "" },
		}
	}

	componentDidUpdate(props, prevProps) {
		console.log("%c" + `In update. ${this.state.limit}`, "background: #222; color: #bada55")
		this.saveFile()
	}

	async saveFile(cut) {
		
		console.log("%c" + `Saving file with ${this.state.limit}`, "background: #222; color: #bada55")
		this.props.loadingStatus(true)
		let eles = document.getElementsByClassName("tablePrinter__page")
		var imgWidth = 200
		let arr = []
		let pageHeight = 295
		let invalid = false
		window.scrollTo(0, 0)
		document.body.style.overflowY = "hidden"
		await helpers.sleep(2000)
		for (let v of eles) {
			// Added computed due to gauges not keeping properties on <text> elements
			v.style.paddingTop = this.props.tableExporting.paddingTop || "90px"
			computedStyleToInlineStyle(v, {
				recursive: true,
				properties: ["font-family", "text-anchor"],
			})

			arr.push(await html2canvas(v, { scrollY: -window.scrollY }))
		}
		if (arr.length > 0) {
			var doc = new jsPDF("p", "mm")
			_.forEach(arr, (v, k) => {
				let imgData = v.toDataURL("image/jpeg")
				var imgHeight = (v.height * imgWidth) / v.width
				var heightLeft = imgHeight
				
				if (imgHeight > pageHeight) {
					invalid = true
					this.setState({limit: this.state.limit / 2})
					
					return false
				}
				while (heightLeft >= 0) {
					var position = heightLeft - imgHeight + 10
					doc.addImage(imgData, "JPEG", 5, position, imgWidth, imgHeight)
					doc.addPage()
					heightLeft -= pageHeight
				}
				if (k + 1 !== arr.length) {
					//doc.addPage()
				}
			})
			if(invalid) { return }
			// Delete last blank page
			var pageCount = doc.internal.getNumberOfPages()
			doc.deletePage(pageCount)
			// Save file..
			let file = this.props.tableExporting.title ? `${this.props.tableExporting.title}.pdf` : "Pipsy-Report.pdf"
			doc.save(file)
			this.props.setTableExporting(_.clone(this.state.model))
			this.props.loadingStatus(false)
			document.body.style.overflowY = "scroll"
		}
	}

	buildTables = () => {
		let data = _.clone(this.props.tableExporting.data)
		console.log(data)
		let columns = this.props.tableExporting.columns
		// First go through and Cell format the dataData
		let chunks = [...Array(Math.ceil(data.length / this.state.limit))].map(() =>
			data.splice(0, this.state.limit)
		)
		return (
			<div>
				{chunks.map((chunk, k) => {
					
					// Ensure columns and chunk keys are inteh right order
					let data = []
					let sortCheck = _.has(this.props.tableExporting, `sorted[0].id`)
					let sort
					if (sortCheck) {
						sort = this.props.tableExporting.sorted[0].id
						// check if asc or desc
						let dir = "asc"
						if (_.has(this.props.tableExporting, `sorted[0].desc`)) {
							dir = "desc"
						}
						chunk = _.orderBy(chunk, sort, dir)
					}
					console.log(chunk)
					return (
						<div className="tablePrinter__page" key={`printerPage-${k}`}>
							<table className="tablePrinter__table">
								<thead>
									<tr>
										{_.map(columns, (v) => {
											if(v.columns) {
												return _.map(v.columns, r => {
													return <th>{v.Header}-{r.Header}</th>
												})
											}
											else {
												if (sort == v.Header) {
													return (
														<th className="sorted" key={v.Header}>
															{v.Header}
														</th>
													)
												}
												return <th key={v.Header}>{v.Header}</th>
											}
											
										})}
									</tr>
								</thead>
								<tbody>
									{_.map(chunk, (v,k) => {
										return (
											<tr key={`${k}-${_.random(0, 300)}`}>
												{_.map(v, (d, k) => (
													<td key={`${k}-${_.random(0, 300)}`}>{d}</td>
												))}
											</tr>
										)
									})}
								</tbody>
							</table>
						</div>
					)
				})}
			</div>
		)
	}

	render() {
		if (this.props.tableExporting.active) {
			return <div className="tablePrinter content">{this.buildTables()}</div>
		} else {
			return ""
		}
	}
}

function mapStateToProps(state) {
	return { tableExporting: state.tableExporting }
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			loadingStatus,
			setTableExporting,
		},
		dispatch
	)
}

export default connect(mapStateToProps, matchDispatchToProps)(TablePrinter)
